<template>
  <v-dialog v-model="dialog" content-class="v-dialog--custom"
    :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-form ref="form" v-model="valid" @submit.prevent="submit()">
      <v-card>
        <v-card-title>
          <span class="headline">Generate Timeclock Report</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <alert-message></alert-message>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <DateRangePicker solo v-model="dateRange" />
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <client-select
                  v-model="form.clients"
                  label="Select Client"
                  multiple
                  chip
                />
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <user-select
                  v-model="form.users"
                  label="Select Users"
                  multiple
                  chip
                />
              </v-col>              
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" @click="dialog = false">Cancel</v-btn>
          <v-btn
            :disabled="$v.$invalid"
            type="submit"
            color="info"
            :loading="loading"
          >
            Generate
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import AlertMessage from "src/components/AlertMessage";
import validationMixin from "@/mixins/validationMixin";
import ClientSelect from "components/ClientSelect.vue";
import UserSelect from "components/UserSelect.vue";
import DateRangePicker from "components/DateRangePicker";

const defaultInputs = {
    clients: null,
    users: null,
};

export default {
  components: {
    AlertMessage,
    ClientSelect,
    DateRangePicker,
    UserSelect
  },
  props: {
    clientId: Number,
    item: Object,
    show: [Boolean, String],
  },
  mixins: [validationMixin],
  validations: {
    form: {
   
    },
  },
  validationMessages: {
    form: {
      
    },
  },

  data() {
    return {
      showDialog: this.show,

      form: {
        ...defaultInputs,
      },

      dateRange: {},

      dialog: false,
      valid: false,
      loading: false,
    };
  },

  watch: {
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },

    dialog(n, o) {
      if (!n && o) {
        this.onDialogClose();
      } else {
        this.onDialogOpen();
      }
    },

    item(n, o) {
      if (n && JSON.stringify(n) !== JSON.stringify(o)) {
        this.form = {
          ..._.pick(n, _.keys(defaultInputs)),
        };
      }
    },
  },

  computed: {
    ...mapState({
      account: (state) => state.account,
      timeclock: (state) => state.timeclock,
      alert: (state) => state.alert,
    }),

  },

  methods: {
    ...mapActions({
      timeclockGenerateReport: 'timeclock/generateApexTimeclockReport'
    }),

    onDialogClose() {
      this.$emit("onClosed");
    },

    onDialogOpen() {
      this.$nextTick(() => {
        // clear error state
        this.$store.dispatch("alert/clear");
        this.$v.$reset();
      });
    },
    completed() {
      this.$emit("onSucceded");
    },
    async submit() {
      const { start, end} = this.dateRange;
      let payload = {
        ...this.form
      };

      if (start) {
        payload.startDate = start;
      }

      if (end) {
        payload.endDate = end;
      }
      this.timeclockGenerateReport(payload);      
    },
  },
};
</script>